const fakeGames = {
    "game0" : {
      "rules" : {
        "game0_rule1585428503206" : {
          "drinks" : "2 drinks",
          "gameKey" : "game0",
          "owner" : "WCRKE62ab8gw6FB2iCYkOX4XmIg2",
          "rule" : "The name of the episode or movie is said or written"
        },
        "game0_rule1585443393434" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "obvious stock footage"
        },
        "game0_rule1585443993724" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "ESL Characters speaking English for no reason"
        },
        "game0_rule1585444223055" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "nut shot"
        },
        "game0_rule1585445102020" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "obviously empty coffee cup"
        },
        "game0_rule1585447770911" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "someone rips up a photo "
        },
        "game0_rule1585507595857" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Incorrect portrayal of \"hacking\""
        },
        "game0_rule1585528860565" : {
          "drinks" : "1",
          "gameKey" : "game0",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "romantic tension between non spouses (will they / wont they characters)"
        }
      },
      "title" : "General Rules"
    },
    "game1" : {
      "parent_game" : "game0",
      "rules" : {
        "game1_rule1" : {
          "drinks" : "1 drink",
          "gameKey" : "game1",
          "rule" : "Bone snap"
        },
        "game1_rule1585442777686" : {
          "drinks" : "1",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Explosion"
        },
        "game1_rule1585442794346" : {
          "drinks" : "2",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "cool explosion (ex: slow mo)"
        },
        "game1_rule1585442823231" : {
          "drinks" : "1",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "unrealistic survival / healing"
        },
        "game1_rule1585442901374" : {
          "drinks" : "1",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "glass breaks"
        },
        "game1_rule1585442925083" : {
          "drinks" : "3",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "decapitation"
        },
        "game1_rule1585443336960" : {
          "drinks" : "1",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "slow motion"
        },
        "game1_rule1585444849287" : {
          "drinks" : "3",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "\"turn in your badge and gun\" / \"youre suspended!\" / etc"
        },
        "game1_rule1585448652082" : {
          "drinks" : "1",
          "gameKey" : "game1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "headshot"
        }
      },
      "title" : "Action"
    },
    "game1585442982618" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game0",
      "rules" : {
        "game1585442982618_rule1585442993103" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Any dino related pun"
        },
        "game1585442982618_rule1585443044303" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Anytime you see a choker or midriff"
        },
        "game1585442982618_rule1585443065678" : {
          "drinks" : "drink til it stops",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Dino roar"
        },
        "game1585442982618_rule1585443084585" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "bad cgi"
        },
        "game1585442982618_rule1585443110038" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "T Rex does something with his hands"
        },
        "game1585442982618_rule1585443158546" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Dinosaur is too big to fit in something"
        },
        "game1585442982618_rule1585443171333" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "poor dino disguising / someone doesnt notice the dino is alive"
        },
        "game1585442982618_rule1585448716738" : {
          "drinks" : "1",
          "gameKey" : "game1585442982618",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "someone grabs someone else's dick"
        }
      },
      "title" : "Tammy and the T Rex"
    },
    "game1585446169128" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game1",
      "rules" : {
        "game1585446169128_rule1585446187228" : {
          "drinks" : "1",
          "gameKey" : "game1585446169128",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "\"enhance\""
        }
      },
      "title" : "Police / Crime"
    },
    "game1585519764301" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game1",
      "rules" : {
        "game1585519764301_rule1585519780902" : {
          "drinks" : "1",
          "gameKey" : "game1585519764301",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Cross Fade"
        },
        "game1585519764301_rule1585519789583" : {
          "drinks" : "1",
          "gameKey" : "game1585519764301",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Saxophone Soundtrack"
        }
      },
      "title" : "Man Hunt"
    },
    "game1585541082218" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game1585541104293",
      "rules" : {
        "game1585541082218_rule1585541134205" : {
          "drinks" : "1",
          "gameKey" : "game1585541082218",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Something is bejewelled"
        },
        "game1585541082218_rule1585541642525" : {
          "drinks" : "1",
          "gameKey" : "game1585541082218",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "a tiger hurts or scares someone"
        },
        "game1585541082218_rule1585545303143" : {
          "drinks" : "1",
          "gameKey" : "game1585541082218",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "tacky / trashy decorations"
        }
      },
      "title" : "Tiger King"
    },
    "game1585541104293" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game0",
      "rules" : {
        "game1585541104293_rule1585751022903" : {
          "drinks" : "1 drink",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Someone Cries"
        }
      },
      "title" : "Reality TV"
    },
    "game1585600289161" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game1",
      "title" : "Jason Statham"
    },
    "game1585600326133" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game1585600289161",
      "rules" : {
        "game1585600326133_rule1585600342757" : {
          "drinks" : "1",
          "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
          "rule" : "Statham uses his boomerang"
        }
      },
      "title" : "In The Name of the king"
    },
    "game1585662389801" : {
      "owner" : "",
      "parent_game" : "game1585541104293",
      "title" : "90 Day Fiance"
    },
    "game1585662406239" : {
      "owner" : "",
      "parent_game" : "game1585541104293",
      "rules" : {
        "game1585662406239_rule1585662454054" : {
          "drinks" : "everyone but the closest guess drinks. Price is right rules",
          "gameKey" : "game1585662406239",
          "owner" : "",
          "rule" : "Everyone guesses the budget of each bride before they say it"
        }
      },
      "title" : "Say Yes To The Dress"
    },
    "game1585872782855" : {
      "owner" : "uGqTXpxQHzg4K7DRhObVWvValvF3",
      "parent_game" : "game0",
      "title" : "test to delete"
    },
    "game2" : {
      "parent_game" : "game1",
      "rules" : {
        "game2_rule1" : {
          "drinks" : "1 drink",
          "gameKey" : "game2",
          "rule" : "Splits"
        }
      },
      "title" : "Jean Claude Van Damme"
    },
    "game3" : {
      "parent_game" : "game0",
      "rules" : {
        "game3_rule1" : {
          "drinks" : "1 sip",
          "gameKey" : "game3",
          "owner" : "WCRKE62ab8gw6FB2iCYkOX4XmIg2",
          "rule" : "Jump Scare"
        },
        "game3_rule1585427944776" : {
          "drinks" : "1 drink",
          "gameKey" : "game3",
          "owner" : "WCRKE62ab8gw6FB2iCYkOX4XmIg2",
          "rule" : "rule added by raymond@raymond"
        }
      },
      "title" : "Horror Movies"
    },
    "game4" : {
      "parent_game" : "game0",
      "title" : "Cartoons"
    },
    "game5" : {
      "parent_game" : "game4",
      "rules" : {
        "game5_rule1" : {
          "drinks" : "drink til it stops",
          "gameKey" : "game5",
          "rule" : "CGI Webslinging"
        }
      },
      "title" : "Adventures of Spiderman"
    }
  }

export default fakeGames;